module.exports = {"320214050":"旺庄街道","320214051":"硕放街道","320214052":"江溪街道","320214053":"新安街道","320214054":"梅村街道","320214055":"鸿山街道","320214450":"无锡新加坡工业园","320214451":"无锡高新技术产业开发区","320214452":"无锡高新区综合保税区","320214453":"无锡太湖国际科技园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320214.json
// module id = 781
// module chunks = 0